<template>
  <interview-layout>
    <!-- inner wrapper used for centering -->
    <div class="container w-100 d-flex flex-column" style="max-width: 480px;">

      <div class="submit-result-indicator">
        <div class="submit-message">
          <div class="text-success pulse-opacity-infinite" v-show="busy">
            <i class="bi bi-arrow-down-up me-2"></i>
            Resultaat opslaan...
          </div>
          <div class="text-success" v-show="resultSubmitted">
            <i class="bi bi-check-lg me-2"></i>
            Opgeslagen!
          </div>
          <div class="text-danger" v-show="!busy && !resultSubmitted">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            Er is iets fout gegaan!
            <span v-if="uiStore.uuid">
              U kunt proberen de pagina te
              <base-button
                variant="danger"
                class="ms-2 d-inline-block"
                icon="bi-arrow-clockwise"
                icon-position="start"
                @click="reloadPage">
                herladen
            </base-button>
            </span>
          </div>
        </div>
      </div>

      <!-- title above form card -->
      <h1 class="px-4 fade-in-up-enter-active animation-slowest max-100">
        <span :class="{'text-primary': overallStatus !== 'all_disqualified', 'text-danger': overallStatus == 'all_disqualified', }">
          {{mainTitle}}
        </span>
      </h1>
      <h5 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100" v-html="subTitle"></h5>

      <!-- result cards were here -->
      
      <transition name="fade-in-up">
        <div class="px-4 mt-5 ms-auto" v-show="!busy || resultSubmitted">
          <return-to-portal-button v-if="lead.meta.ReturnUrl" text-align="end" />
        </div>
      </transition>

      <transition name="fade-in-up">
        <div class="call-request-container px-4 mt-5 ms-auto" v-show="!anyQualified && !lead.meta.ReturnUrl">
          <call-request-card />
        </div>
      </transition>

      <button-row class="mt-4">
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
          <base-button class="ms-auto" icon="bi-arrow-right" type="submit" @click="onSubmit" :disabled="busy || !resultSubmitted">Volgende</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
  // import BaseCard from '@/components/BaseCard.vue';
  import BaseButton from "@/components/BaseButton.vue";
  import ButtonRow from "@/components/ButtonRow.vue";
  // import QualIssueSummary from "@/components/QualIssueSummary.vue";
  import CallRequestCard from "@/components/CallRequestCard.vue";
  // import AppointmentScheduler from "@/components/AppointmentScheduler.vue";
  import ReturnToPortalButton from "@/components/ReturnToPortalButton.vue";

  import { useAllStores } from "@/helpers/UseAllStores";
  import { FlowService } from "@/services/FlowService";
  import { useQualificationStore, enabledSections } from '@/store/QualificationStore';
  import PushWithParams from "@/helpers/PushWithParams";
  import { StripQuery } from "@/helpers/StripQuery";

  import { filter } from 'lodash';
  import { FacebookPixelService } from "@/services/FacebookPixelService";
  import { LeadDataService } from "@/services/LeadDataService";

  export default {
    components: {
      InterviewLayout,
      // BaseCard,
      BaseButton,
      ButtonRow,
      // QualIssueSummary,
      CallRequestCard,
      // AppointmentScheduler,
      ReturnToPortalButton
    },
    setup() {
      let qualStore = useQualificationStore();
      return {...useAllStores(), qualStore};
    },
    data() {
      return {
        expandedIssueSummary: '',
        busy: false,
        resultSubmitted: false,
        showAppointmentScheduler: false
      }
    },
    computed: {
      overallStatus() {
        return 'all_qualified';
      },
      anyQualified() {
        return (this.overallStatus == 'all_qualified' || this.overallStatus == 'partially_qualified');
      },
      mainTitle() {
        if (this.resultSubmitted) {
          return 'U bent aangemeld';
        }
        return 'U wordt aangemeld...';
      },
      subTitle() {
        return 'Ga verder om uw situatie te beoordelen en direct een telefonische afspraak in te plannen.';
      },

      anySummaryExpanded() {
        return this.expandedIssueSummary !== '' && this.expandedIssueSummary !== ' ' && this.expandedIssueSummary;
      },

      allSections() { // all checked interests
        return enabledSections.value;
      },
      qualifiedSections() { // qualified sections only
        return filter(this.qualStore.sections, (section) => {
          return section.qualified == true;
        });
      }
    },
    methods: {
      toggleIssueSummary(sectionKey) {
        this.expandedIssueSummary = this.expandedIssueSummary == sectionKey ? '' : sectionKey;
      },
      otherSummaryExpanded(sectionKey) {
        return this.anySummaryExpanded && this.expandedIssueSummary !== sectionKey;
      },
      onNavigateToIssueView(viewName) {
        PushWithParams(
          this.$router,
          this.$route,
          {
            name: viewName,
            query: { 'from_result': 'true' }
          },
          true);
      },
      toggleAppointmentScheduler() {
        this.showAppointmentScheduler = !this.showAppointmentScheduler;
      },

      submitResult() {
        this.busy = true;
      
        LeadDataService.pushRemoteData(this.uiStore.uuid, true)
        .then(() => {
          this.resultSubmitted = true;
          FacebookPixelService.trackOnce(
            'facebook_lead:saved',
            'Lead'
          );
        })
        .catch(() => {
          this.resultSubmitted = false;
          console.log('Failed to submit result.');
        })
        .then(() => {
          this.busy = false;
        });
      },

      onPrev() {
        FlowService.pushPrev(this);
      },
      sectionOverviewCardColor(section) {
        if (section.status == 'qualified') {
          return 'success';
        } else if (section.status == 'disqualified') {
          return 'danger';
        } else {
          return 'secondary';
        }
      },
      reloadPage() {
        window.location.reload();
      },
      onSubmit() {
        FlowService.pushNext(this);
      },
    },
    beforeRouteEnter(to) {
      if ('from_result' in to.query) {
        to.query = StripQuery(to.query, 'from_result');
        return to;
      }
    },
    mounted() {
      this.submitResult();
    }
  }
</script>

<style scoped lang="scss">
.issue-summary-button-wrapper {
  font-size: 0.8em;
  text-align: center;
}
.overview-item {
  cursor: pointer;
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 1 !important;
  }
}

.submit-result-indicator {
  padding: 0 map-get($spacers, 4);
  margin-bottom: map-get($spacers, 2);
  opacity: 0.7;

  .submit-message {
    font-weight: 600;
    font-size: 0.8em;
    text-transform: uppercase;
  }
}
</style>

<style lang="scss">
  .calendly-brand-bg {
    background-color: #fbfcfd !important;
  }
  .appointment-scheduler-bubble {
    &-inner {
      display: flex;
      align-items: center;
      @include std-box-shadow(4, 10, map-get($theme-colors, 'success'), true);
    }
    &-avatar {
      border-radius: 99px;
      height: 50px;
    }
  }
</style>
